import React from 'react';
import WarningIcon from '@material-ui/icons/Warning';
import style from './style/maintenancewidget.scss';

/**
 * Maintenance mode widget
 * @param {Object} props - props
 * @returns {JSX.Element} component
 * @constructor
 */
export default function MaintenanceWidget(props) {
    const { relative = false, title = '', description = '' } = props;

    return (
        <div className={ `${style.fullPage} ${relative ? style.relative : ''}` }>
            <div className={ style.wrapper }>
                <div className={ style.content }>
                    <WarningIcon />
                    <h3>
                        { title }
                    </h3>
                    <p>
                        { description }
                    </p>
                </div>
            </div>
        </div>
    );
}
